var React = require('react');

function Speed (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"51.08","y1":"41.19","x2":"62.15","y2":"29.68","key":0}),React.createElement("circle",{"cx":"46.03","cy":"46.03","r":"44.03","key":1}),React.createElement("path",{"d":"M16.24,45.76a30.1,30.1,0,1,1,60.2,0","key":2}),React.createElement("circle",{"cx":"46.03","cy":"46.03","r":"6.86","key":3})]);
}

Speed.defaultProps = {"className":"svg-speed","viewBox":"0 0 92.07 92.07","stroke":"#000000","fill":"none"};

module.exports = Speed;

Speed.default = Speed;
